export default __webpack_public_path__ + "static/media/step_02.4cb0f1c3.svg";